<template>
  <v-row class="d-flex justify-center ma-0 pa-0 fill-height">
    <v-col cols="12" lg="10" md="7">
      <v-card class="card-shadow bg-secondary">
        <ExibicaoRegulamento />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ExibicaoRegulamento from "../Components/Exibicoes/ExibicaoRegulamento.vue";
export default {
  name: "ShowRule",
  components: {
    ExibicaoRegulamento,
  },
  data() {
    return {};
  },
};
</script>
